import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import './index.css';
import reducers from './reducer';
import App from './App';

const store = createStore(
  reducers, /* preloadedState, */
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const Calculator = () =>
  <Provider store={store}>
    <App />
  </Provider>

export default Calculator;
